import { render, staticRenderFns } from "./LitterSignature.vue?vue&type=template&id=8a04f348"
import script from "./LitterSignature.vue?vue&type=script&lang=ts"
export * from "./LitterSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports